import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {IsUserAuthorized} from "./services/authguard";

const routes: Routes = [
  {
    path: "home",
    loadChildren: () =>
      import("./loggeduser/loggeduser.module").then((m) => m.LoggeduserModule),
    canActivate: [IsUserAuthorized],
    pathMatch: "prefix",
  },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
    pathMatch:'prefix'
  },
  {
    path:'',
    pathMatch:'full',
    redirectTo:'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],

})
export class AppRoutingModule { }
